import React from 'react';
import { InStorePickup } from '@one-thd/sui-icons';
import { LearnMore } from './LearnMore';

export const LearnMoreShipping = () => {
  return (
    <LearnMore
      icon={<InStorePickup size="large" color="brand" />}
      title="Buy Online Ship To Store"
      link="/c/About_Your_Online_Order#bosts"
    >
      <p>Free In-store pick-up</p>
      <p>Over a million online items eligible</p>
    </LearnMore>
  );
};

LearnMoreShipping.displayName = 'LearnMoreShipping';
